'use strict';

if (!window.i18n) {
    window.i18n = {};
}

if (!window.i18n.languages) {
    window.i18n.languages = {};
}

window.i18n.languages['zh_CN'] = {
    optional:"选填",
    needBet: "还需打码:",
    needDeposit:"还需存款:",

    agentCode : "邀请码",

    tips_fail:"领取失败",

    a_stauts:"活动状态",
    activityDetails_hdjxz: "活动进行中",
    activityDetails_hdwks: "活动未开始",
    activityDetails_hdyjs: "活动已结束",
    a_time: `活动时间`,
    a_status: `活动状态`,
    a_rule: `奖励规则`,
    a_content: `活动细则`,

    gameCoin:"游戏币",
    register_chooseCurrency: "请选择充值币种",
    register_tips0:"*注册后您的币种将不可以更改",
    register_curInstruction:"币种说明：",
    register_tips1:"1、进入不支持用户当前币种的游戏时,会以汇率转换的金额带入游戏；",
    register_tips2:"2、用户存款/提款方式是显示用户当前币种支持的",

    sendSuccess:"发送成功！",
    login_areaCode: '国家/区号',
    login_selectAreaCode: '选择国家或区域',

    new_maxVipLV: '恭喜您！！您目前已经是最高等级了',

    currency_symbol : "¥",
    language : "中文",


    new_r_tips9: '您当前正在进入',
    new_r_game :"游戏",

    new_r_rate: '请注意进入游戏的金额是汇率转换后的金额',
    new_r_rate1: '转换汇率：',
    new_r_money: '进入游戏的金额：',//重新翻译

    new_r_tips6: '*请注意转入三方游戏只能带入整数',
    new_r_tips7: '汇率提示',
    new_r_tips8: '我知道了',


    "ActivityNew" : {
        "btn_lingqu" : "立即领取",
        "btn_back" : "返回",
        "toggle_zonghe" : "综合活动",

    },

    "SignIn":{
        "btnLingqu": "领取",
    },

    "label_text": {
        "title": "获得奖励",
        "loading_msg": "正在为您下载更新资源包",
        "not_logged": "未登录",
        "password": "密码：",
        "verify": "验证码：",
        "verify_msg": "请输入验证码",
        "inPlease_enter_the": "请输入",
        "phone": "手机",
        "No": "号",
        "determine": "确定",
        "receive": "领取",
        "Image_preview": "头像预览",
        "Install": "立即安装",
        "obtain": "恭喜您获得",
        "check_update": "正在检查更新...",
        "real_name": "真实姓名",
        "tips": "抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。",
        "tishi": "提示",
        "no_data": "暂无数据",
        "queding": "确定",
        "quxiao": "取消",
        "download_new_version": "请下载最新版应用以使用此功能",
        "online_kefu": "在线客服",
        "save_account": "保存账号资料",
    },

    "data_req_text": {
        "login_failure": "登录已失效，请重新登录",
    },

    "login_text": {
        "account_pro": "账号不能为空，请填写！",
        "psw_pro": "密码不能为空，请填写！",
        "vfy_pro": "验证码不能为空，请填写！",
        "quick_login_fail": "快速登录失败！",
        "account": "账号：",
        "account_msg": "请输入账号/手机号",
        "paw_msg": "请输入密码",
        "Remember_acc": "记住账号",
        "forget_paw": "忘记密码？",
        "no_acc": "没有账号,",
        "go_reg": "前往注册>",
        "confirm_login" : "确认登录",
        "quick_login": "快速登录",
        "confirm_register" : "确认注册",
        "register_cg": "注册成功",
        "account_data": "账号资料",
        "sfyz": "身份验证",
        "sfyz_tip": "尊敬的客户您好！为了保护您的账户安全，本次登录需要以下验证，防止恶意程序自动登录。",
        "bind_bank": "请输入绑定的银行卡",
        "bind_alipay": "请输入绑定的支付宝",
        "bank_card": "银行卡：",
        "alipay": "支付宝：",
        "code": "验证码：",
        "enter_bank_card": "请输入银行卡号",
        "enter_alipay": "请输入支付宝账号",
        "enter_code": "请输入验证码",
    },

    "register_text": {
        "perfect_suc": "完善资料成功！",
        "perfect_err": "完善资料失败！",
        "inp_data": "请先输入资料！",
        "inp_email": "请输入邮箱",
        "inp_phone": "请输入手机号",
        "inp_wx": "请输入微信号",
        "inp_qq": "请输入QQ号",
        "email": "邮箱：",
        "wx_No": "微信：",
        "qq_No": "QQ号：",
        "phone": "手机号：",
        "user_name": "用户名：",
        "user_msg": "请输入6-12位字母与数字组合的账号",
        "user_pro": "请输入6-12位字母与数字组合的账号",
        "paw_pro": "请输入6-12位字母数字或字符的密码",
        "confirm_paw_pro": "确认密码不能为空，请填写！",
        "paw_consistent": "密码和确认密码不一致，请重新填写！",
        "paw_msg": "请输入6-12位字母数字或字符的密码",
        "confirm_msg": "请再次确认密码",
        "phone_msg": "请输入手机验证码",
        "con_paw": "确认密码：",
        "exi_acc": "已有账号，",
        "go_log": "前往登录>",
        "send_verify": "发送验证码",
        "retry_verify": "重新发送",
        "phone_confirm": "输入正确的手机号码！",
        "register_suc": "注册成功！",
        "user_not_mag": "用户名不能为空，请填写！",
        "No_null": "号不能为空，请填写！",
        "correct_phone": "输入正确的手机号码！",
        "phone_vfy": "手机验证码不能为空，请填写！",
        "loss_account": "为了防止账号丢失，请保存账号",
        "account_change": "账号只能修改一次，点击修改",
        "please_tick": "请先点击打勾按钮确认账号密码！",
        "save_suc": "保存成功！",
        "save_err": "保存失败,请手动截图！",

        "currency": "币种：",
        "language": "语言：",

    },

    "datum_text": {
        "datum_title": "提交资料",
        "bank_card": "银行卡号：",
        "inPlease_enter_the": "请输入...",
        "input_datum": "请先输入资料",
        "update_img": "上传图片",
        "select_update_img": "请选择上传的图片",
        "limit_type": "只能上传JPG、JPEG、PNG",
        "msg_update_data": "请先上传资料",
        "mag_update_pic": "请先上传正确格式的图片",
        "apply_succ": "提交申请成功，请等待审核",
    },

    "task_text": {
        "activity": "活动",
        "task": "任务",
        "announcement": "公告",
        "sign": "签到",
        "task_name": "任务名称：",
        "task_detail": "任务详情",
        "task_time": "任务有效时间：",
        "task_content": "任务内容：",
    },

    "customer_text": {
        "jump_whatsapp": "whatsapp账号复制成功，请求跳转whatsapp",
        "jump_telegram": "telegram账号复制成功，请求跳转telegram",
        "jump_Messenger": "Messenger账号复制成功，请求跳转Messenger",
        "jump_Viber": "Viber账号复制成功，请求跳转Viber",
        "no_whatsapp": "您的设备尚未安装whatsapp",
        "no_telegram": "您的设备尚未安装telegram",
        "no_Messenger": "您的设备尚未安装Messenger",
        "no_Viber": "您的设备尚未安装Viber",


        "contact_customer": "联系客服",
        "not_ind_qq": "您的设备尚未安装QQ",
        "jump_wx": "微信账号复制成功，请求跳转微信",
        "not_ind_wx": "您的设备尚未安装微信",
        "jump_mt": "MT客服账号复制成功，请求跳转MT客服",



        "Online": "在线客服",
        "QQ": "QQ客服",
        "WECHAT": "微信客服",
        "MT": "MT客服",


        "CJ": "常见问题",
        "contact_online": "联系客服",
        "copy_wx": "复制微信号",
        "copy_mt": "复制MT号",
    },

    "msg_text": {
        "save_date": "消息最多保存一个月",
        "message": "消息",
        "email": "邮件",
        "receive": "已领取",
        "overdue": "已过期",
        "not_delete": "不可删除，请先领取奖励",
        "not_be_deleted": "未领取的邮件将不会被删除",
    },

    "basic_text": {
        "basic_title": "基本信息",
        "account": "账 号：",
        "nickname": "昵 称：",
        "name": "姓 名：",
        "com_title": "通讯信息",
        "qq": "Q Q：",
        "wx": "微 信：",
        "phone": "手 机：",
        "email": "邮 箱：",
    },

    "baes_text": {
        "unit": "元",
        "view": "查看 》",
        "yes": "是",
        "no": "否",
        "update": "更新",
        "cancel": "取消",
        "mail_system": "系统邮件",
        "connected": "正在连接中，请耐心等待...",
        "coin": "金币",
    },

    "pre_details_text": {
        "detail": "充值详情",
        "lxkf": "联系客服",
        "rkz": "入款中...",
        "copy": "复制",
        "order": "订单号",
        "date": "充值时间",
        "czType": "充值方式",
        "transfer": "转账",
        "succ": "成功",
        "error": "失败",
        "audit": "审核中",
        "czSucc": "充值失败",
        "copy_succ": "复制成功",
        "order_num": "订单号",
    },

    "USDT_text": {
        "second_step": "第二步：USDT链信息",
        "url_name": "链名称",
        "alipay": "支付宝支付",
        "url": "链地址...",
    },

    "set_text": {
        "set_music": "音乐设置",
        "switch_music": "音乐切换",
        "change_d_paw": "修改登录密码",
        "change_t_paw": "修改提现密码",
        "version": "当前版本",
        "huidu": "灰度版",
        "swi_test": "是否切换为测试版？",
        "swi_hui": "是否切换为灰度版？",
        "old_paw_null": "旧密码不能为空，请填写！",
        "new_paw_null": "新密码不能为空，请填写！",
        "old_paw_limit_length": "旧密码为6-12位",
        "new_paw_limit_length": "新密码为6-12位数字与字母组合",
        "new_paw_limit": "旧密码应为6位数，请重新填写",
        "con_paw_null": "确认密码不能为空，请填写！",
        "con_paw_consistent": "密码和确认密码不一致，请重新填写！",
        "new_old_paw_consistent": "新密码跟旧密码不能一样，请重新填写！",
        "change_succ": "恭喜您，修改密码成功，请重新登录！",
        "tx_paw_null": "提现密码不能为空，请填写",
        "con_tx_paw": "确认提现密码不能为空，请填写",
        "tx_paw_consistent": "提现密码与确认密码不一致，请确认",
        "tx_paw_limit": "提现密码应为6位数，请重新填写",
        "paw_change_succ": "恭喜您，修改密码成功",
        "latest_version": "这已经是最新版的App",
        "switch_server": "切换服务器",
        "switch_language": "切换语言",
        "change_language_tips": "部分页面的语言将在重启应用后生效",
        "restart": "重启",
    },

    "share_text": {
        "copy_wa": "复制文案",
        "save_img": "保存图片",
        "share_py": "分享朋友圈",
        "submit_audit": "提交审核",
        "copy_succ": "复制成功",
        "save_img_succ": "保存图片成功",
        "save_err": "保存图片失败。请前往手机设置页面，打开本应用存储图片的权限",
        "share_go": "分享到：",
        "share_err_qq": "分享失败，请安装或检查QQ后重试",
        "share_err_wx": "分享失败，请安装或检查微信后重试",
        "share_err_wl": "绑定失败，请检查网络后重试",
        "shareIntroduce_title": "分享教程",
        "inviteFriends":"邀请好友",
    },

    "hot_text": {
        "dzyx": "汇聚全球热门电子游戏 热度不减 胜率更高 千万礼金等你赢取！",
        "qbyx": "汇聚全球热门棋牌游戏 热度不减 胜率更高 千万礼金等你赢取！",
        "byyx": "汇聚全球热门捕鱼游戏 热度不减 胜率更高 千万礼金等你赢取！",
        "rmqp": "热门棋牌",
        "rmdz": "热门电子",
        "rmby": "热门捕鱼",
        "ljyx": "立即游戏",
    },

    "agent_text": {
        "my_id": "我的ID：",
        "under": "昨日直属佣金：",
        "offline": "昨日下线佣金：",
        "under_player": "直属玩家：",
        "day_new": "昨日新增：",
        "offline_player": "下线玩家：",
        "bind_wx": "绑定微信",
        "share_rewards": "分享奖励：",
        "commission_ins": "佣金结算日期为日结，分享好友或朋友圈可以获得分享奖励哟！",
    },

    "vip_text": {
        "title": "我的VIP",
        "backToMe":"回到我的",
        "me":"我",
        "my_level": "我的等级：",
        "current_code": "当前打码量：",
        "was_filed": "晋级彩金",
        "was_filed_info": "晋级即可领取彩金",
        "weeks_amounts": "周礼金",
        "weeks_amounts_info": "每周一免费发放",
        "month_amounts": "月礼金",
        "month_amounts_info": "每月1号准时发放",
        "wash_code": "洗码",
        "wash_code_info": "最高洗码比例",
        "but_text": "立即前往",
        "get_error": "获取金币失败，请重新刷新金币！",
        "amount_code": "打码金额",
    },

    "xima_text": {
        "game_type": "游戏类型",
        "dm_total": "有效投注额",
        "proportion": "最高洗码比例",
        "xm_amount": "洗码金额",
        "can_led_take": " 可  领  取",
        "xm_total": "洗码总额",
    },

    "PlayerCenter": {
        "jbxx": "基本信息",
        "zhmx": "账户明细",
        "zdlb": "注单列表",
        "my_vip": "我的VIP",
        "save": "保存",
        "edit": "编辑",
        "note": "备注",
        "betting_record": "投注记录",
        "trading_hours": "交易时间",
        "trading_type": "交易类型",
        "change_amount": "金额变动",
        "balance": "余额",
        "today": "今天",
        "yesterday": "昨天",
        "a_month": "一个月",
        "all": "全部",
        "status": "交易状态",
        "chess": "棋牌",
        "send_time": "派彩时间",
        "note_num": "游戏—注单号",
        "betting_amount": "投注金额",
        "has_been": "已派奖",
        "gaming": "游戏平台",

        "currencyType":"转换币种",
        "rate":"汇率",
    },

    "RechargeLayer": {
        "note": "备注",
        "often_play": "玩家常玩的快捷金额",
        "between": "请输入1~100之间的金额",
        "gift100": "赠100%",
        "payment_account": "收款账号",
        "payee": "收款人",
        "where": "开户行",
        "depositors": "请填写存款人真实姓名",
        "note_info": "备注信息",
        "step": "第一步：扫描收款二维码并进行充值",
        "step2": "第二步：填写您的充值信息，提交充值",
        "session": "最近会话",
        "official": "官方认证",
        "gift2": "赠2%",
        "channel": "*请选择充值渠道\n*选择渠道前，请仔细核对汇率",
        "qr_code": "保\n存\n二\n维\n码",
        "digital_currency": "数字货币充值渠道1",
        "step_1": "第一步：选择USDT金额",
        "formula": "最终充值到账户金额的计算公式：70.86=10.1234USDT*当前汇率7元",
        "step3": "第三步：提供提币信息",
        "actual_account": "实际到账USDT金额",
        "poundage": "手续费0-50USDT",
        "instr": "*请按照左图所示，严格填写！\n*如填写错误，将不能按时到账！",
        "not_account": "充值未到账?",
        "rate": "汇率：1USDT=99元",
        "prompt_info": "提示信息",
        "czjl": "充值记录",
        "czjc": "充值教程",
        "ljcz": "立即充值",
        "czje": "充值金额",
        "zfpz": "支付凭证",
        "save_code": "保存二维码",
        "xuanchuan": "官方代理充值\n        绝对信誉保证",
        "usdt_address": "USDT充值地址：",
        "syb": "上一步",
        "complete": "完成",
        "usdt_num": "充值USDT金额：",
        "go_recharge": "前往充值",  
        "back" : "返回",
        "creat_order" : "创建订单",
        "real_usdt" : "实际到账USDT金额",
        "sxf" : "手续费",
        "date" : "时间",
        "state" : "状态",
        "jine" : "金额",
        "detail" : "详情",
        "rechargeCourse":"充值教程",
        "rate2coin": "汇率：1金币 = ",
        "currency_symbol": "¥",
        "currency_word": "RMB",
        "get_coins": "到账金币：",
        "get_money": "到账金额：",
        "go_pay": "复制成功，是否立即前往支付？",
        "pay_now": "立即支付",
        "pay_not_support": "暂不能进行支付！",
    },

    "SettingLayer": {
        "bind_equi": "设备绑定",
        "basic_info": "基础信息",
        "account": "账 号：",
        "level": "等 级：",
        "set_sound": "声音设置",
        "music": "音乐",
        "sound": "音效",
        "switch_music": "音乐切换",
        "song2": "死了都要爱",
        "song1": "歌曲1",
        "inp_landing_paw": "请输入登录密码",
        "inp_old_paw": "请输入旧密码",
        "old_paw": "旧密码：",
        "inp_new_paw": "请输入新密码",
        "new_paw": "新密码：",
        "con_new_paw": "确认新密码",
        "con_paw": "确认密码：",
        "check_update": "检查更新",
        "determine": "确定",
        "bind_shuom1": "*绑定设备后，可使用快速登录，直接登录绑定设备。",
        "bind_shuom2": "*通过快速登录注册账号，自动绑定当前设备。",
        "bind_shuom3": "*绑定设备后，可验证身份解除绑定。",
        "bind_shuom4": "*验证身份，需要输入账号的登录密码。",
        "bind_shuom5": "*请谨慎使用！",
        "bind_shuom6": "已绑定当前设备",
        "bind_shuom7": "已绑定其它设备",
        "landing_paw": "登录密码：",
        "test1": "测试环境1-多币种",
        "test2": "测试环境2-非国际化",
        "test3": "测试环境3-新需求",
        "huidu1": "灰度环境1-非国际化",
        "huidu2": "灰度环境2-多币种",
        //"standbyTest": "备用测试环境",
        "mute_all": "全部静音",
        "change_account": "切换账号",
        "confirm_change": "确认修改",
        "confirm_bind": "设备绑定",
        "unbind_device": "解除设备绑定",
        "unbind": "解除绑定",
    },

    "Task": {
        "share_task": "分享任务",
        "MG_electronic": "MG电子",
        "cash": "现金",
        "complete": "去完成",
        "application": "申请中",
        "refused": "已拒绝",
        "disclose_data": "提交资料",
        "submit": "提交",
        "Audit_failure": "审核失败",
        "friends_account": "提交截图",
        "apply_reward": "申请奖励",
        "pic_limit": "只能上传JPG、JPEG、PNG，不能超过1M",
        "btn_choose" : "选择",
        "update_pic": "上传图片：",
        "editTips" : "请选择上传的图片",
        "task_details": "任务详情",
        "Task_details": "任务详情：",
        "task_name": "任务名称：",
        "task_state": "任务说明：",
        "share": "分享",
        "task_progress": "任务进度：",
        "know": "我知道了",
        "q_update_pic": "请先上传图片",
        "activit_Shut": "任务活动已关闭",
        "Qbind_wx": "请先绑定微信",
        "Application_success": "申请成功，请等待审核",
        "Succ_application_Award": "申请奖励成功",
        "task_ShutDown": "分享任务已关闭",
    },

    "ThirdGamesListLayer": {
        "xsj": "新世界棋牌",
        "tall_game": "总共1款游戏",
        "inp_game": "请输入游戏名",
    },

    "TuiGuangLayer": {
        "title":"推广代理",
        "my_agent": "我的代理",
        "agent_recruit": "代理招募",
        "agent_introduced": "代理介绍",
        "players_query": "玩家查询",
        "results_query": "业绩查询",
        "rich_list": "财富榜",
        "my_id": "我的ID：",
        "under": "昨日直属佣金：",
        "offline": "昨日下线佣金：",
        "under_player": "直属玩家：",
        "day_new": "昨日新增：",
        "offline_player": "下线玩家：",
        "share_rewards": "分享奖励：",
        "commission_ins": "佣金结算日期为日结，分享好友或朋友圈可以获得分享奖励哟！",
        "save_qr_code": "保存二维码",
        "copy": "复制",
        "bind_wx": "绑定微信",
        "Imm_receive": "立即领取",
        "share_detail": "分享明细",
        "get_record": "领取记录",
        "historyCom": "历史总佣金",
        "canReceive": "可领取佣金",
        "zhishu_renshu": "直属人数：",
        "tall_bets_today": "今日有效总投注：",
        "inp_id": "请输入ID",
        "query": "查询",
        "reset": "重置",
        "bets_today": "今日有效投注",
        "total_bets": "总有效投注",
        "directly_num": "直属人数",
        "operation": "操作",
        "details": "详情>>",
        "date": "日期",
        "under_new": "直属新增",
        "team_new": "团队新增",
        "directly_under": "直属返佣",
        "total_amount": "返佣总额",
        "reward": "奖励",
        "contact" : "联系导师",
        "ranking": "排名",
        "player_info": "玩家信息",
        "rebate_month": "本月返佣奖励",
        "rewards_month": "本月分享奖励",
        "detailed_info": "详细信息",
        "zhuce_shijian": "注册时间：",
        "jtyxtz": "今日有效投注：",
        "tdrsxz": "团队人数（新增）：",
        "jrtdyxtz": "今日团队有效投注：",
        "directly_num_new": "直属人数（新增）：",
        "zuoriyongjing": "昨日佣金：",
        "commission_payable": "可提取佣金：",
        "lishizongyong": "历史总佣金：",
        "zyxtz": "总有效投注：",
        "agent_commission": "代理佣金",
        "share_commission": "分享佣金",
        "team_num": "团队人数",
        "not_directly_under": "非直属返佣",
        "account": "账号",
        "between": "关系",
        "effective_betting": "有效投注/返佣金额",
        "ratio": "返佣比例",
        "total": "总计",
        "share": "分享",
    },

    "WithdrawLayer": {
        "self_help": "自助提现",
        "withdrawal_record": "提现记录",
        "wallet_management": "钱包管理",
        "inp_withdrawal_amount": "请输入提现金额",
        "warm_prompt": "温馨提示",
        "current_need_adjust_amount": "当前还需<color=#00ff00>0</c>流水，方可提现",
        "current_need": "当前还需",
        "can_carry": "流水，方可提现",
        "adjust_amount": "拖住圆点可调节提现金额",
        "bank": "工商银行",
        "change_bank_card": "更换银行卡",
        "not_bind_card": "您暂时未绑定银行卡，请前往绑定",
        "not_tixian_paw": "您尚未设置提现密码，请先设置提现密码",
        "tixian_paw": "提现密码",
        "set6num_paw": "请设置6位数字密码",
        "confirm_password": "确认密码",
        "again_confirm_password": "请再次输入密码，以确认",
        "inp_tixian_paw": "请输入提现密码",
        "topUp_failure": "充值失败",
        "bank_paragraph": "银行出款",
        "add_card": "添加银行卡",
        "cardholder_name": "请输入持卡人姓名",
        "cardholder": "持卡人：",
        "card_code": "银行卡账号：",
        "inp_bank_card_code": "请输入银行卡卡号",
        "inp_bank_address": "请输入开户行地址",
        "bank_address": "开户地址：",
        "bank_address_msg": "提示：请正确选择开户行，并绑定真实姓名，结算时将直接转入改账号，为了您的资金安全，绑定后不可随意更改，如需修改，请联系客服人员。",
        "choose_bank": "选择银行：",
        "inp_aliPay_name": "请输入支付宝真实姓名",
        "inp_aliPay_code": "请输入支付宝账号",
        "name": "姓名：",
        "aliPay_account": "支付宝账号：",
        "aliPay_account_msg": "提示：请正确选定支付宝，结算时将直接转入改账号，为了您的资金安全，绑定后不可随意更改，如需修改，请联系客服人员。",
        "inp_tixian_dizhi": "请输入提现地址",
        "rate": "汇率",
        "daozhangUSDT": "到账USDT金额",
        "confirm_tixian": "确认提现",
        "max": "最大",
        "confirm_submit": "确定提交",
        "tixian_time": "提现时间",
        "jine": "金额",
        "state": "状态",
        "order_info": "订单信息",
        "confirm_bind": "确定绑定",
        "confirm_select": "确定选择",
        "select_bank_card": "选择银行卡",
        "bizhong_xuanze": "币种选择：",
        "tixian_dizhi": "提现地址：",
        "more_than_0": "提现金额应大于0",
    },

    "XimaLayer": {
        "title": "洗码",
        "selfHelp_washing": "自助洗码",
        "xima_record": "洗码记录",
        "xima_proportion": "洗码比例",
        "fishing_game": "捕鱼游戏",
        "to_complete": "去完成",
        "receive": "领取",
        "chess": "棋牌",
        "fishing": "捕鱼",
        "electronic": "电子",
        "reality": "真人",
        "sports": "体育",
        "eSports": "电竞",
        "lottery": "彩票",
        "game": "游戏",
        "key_get": "一键领取",
        "get_time": "领取时间",
        "damaliang": "有效投注额",
        "xima_amount": "洗码金额",
        "details": "详情",
        "viewI": "查看>>",
        "xima_details": "洗码详情",
        "heitao_chess": "黑桃棋牌",
        "chess_game": "棋牌游戏",
        "sports_events": "体育赛事",
        "electronic_game": "电子游艺",
        "lottery_betting": "彩票投注",
        "real_video": "真人视讯",
        "eSports_game": "电竞游戏",
        "game_name": "游戏名",
        "click_details": "点击详情",
        "tianmei_chess": "天美棋牌",
        "detailsI": "详情>>",
        "xima_range": "洗码范围",
        "vip_level": "Vip等级",
        "tournament": "电竞赛事",
        "lottery_game": "彩票游戏",
    },

    "Signal": {
        "switch": "切换线路",
        "speed": "加速线路",
        "choose": "选择线路",
        "reconnect": "重新连接",
        "helpful_hints": "友情提示：延迟越低，网络越好",
        "is_msg": "这是一条信息",
        "in_test": "检测中",
        "general": "一般",
        "smooth": "流畅",
        "speed1": "极速",
        "current_use": "当前使用",
    },

    "general": {
        "name": "姓名",
        "activity": "综合活动",
        "xzsm": "地址发布器，随时获取最新安装地址。",
        "wszl": "完善资料",
        "qdcj": "签到彩金",
        "xtyj": "系统邮件",
        "xxzx": "消息中心",
        "bt": "标题",
        "sj": "时间",
        "nr": "内容",
        "xx": "消息",
        "dlq": "待领取",
        "ylq": "已领取",
        "ygq": "已过期",
        "ready_all": "全部已读",
        "del_all": "全部删除",
        "get_all": "全部领取",
    },

    "EllipticalStage": {
        "musicNmae": "为了胜利",
    },

    "CheckHot": {
        "update_msg": "检测到新版本更新，已为您下载完毕，点击即可完成更新！",
        "update": "更新",
        "lack_resources": "缺少美术资源",
        "kaiyuan_chess": "开元棋牌",
        "leyou_chess": "乐游棋牌",
        "xinshijie_chess": "新世界棋牌",
        "ag_electronic": "AG电子",
        "pg_electronic": "PG电子",
        "mg_electronic": "MG电子",
    },

    "HallUI": {
        "copy_succ": "复制成功",
        "moment_open": "暂未开放",
        "no_announcement": "暂无公告内容",
        "tmpled_err": "模版配置错误，请联系客服",
        "game_maintain": "游戏维护中",
        "game_loading": "游戏正在加载中",
        "get_err": "获取金币失败，请重新刷新金币！",
        "login": "登录",
        "register": "注册",
        "copy_id": "复制ID",
        "huodong": "活动",
        "task": "任务",
        "setting": "设置",
        "remen": "热门",
        "qipai": "棋牌",
        "buyu": "捕鱼",
        "zhenren": "真人",
        "dianzi": "电子",
        "tiyu": "体育",
        "caipiao": "彩票",
        "dianjing": "电竞",
        "tuiguangdaili": "推广代理",
        "xima": "洗码",
        "xiaoxi": "消息",
        "kefu": "客服",
        "xiufugongju": "修复工具",
        "gengduo": "更多",
        "qiandao": "签到",
        "paihangbang": "排行榜",
        "gonggao": "公告",
        "tixian": "提现",
        "chongzhi": "充值",
        "xianshilingqu": "限时领取",
        "remenyouxi": "热门游戏",
        "zuijingchangwan": "最近常玩",
        "play_now": "立即投注",
    },

    "BasicsJS": {
        "tall": "总共",
        "minGame": "款小游戏",
        "play_game": "没有最近常玩的游戏",
        "editor_succ": "编辑成功",
        "yi_bind": "已绑定",
        "wu_bind": "未绑定",
        "inp_amount": "请输入充值金额",
        "inp_correct_amount": "请输入正确的充值金额",
        "no_login_yinshang": "未登录银商",
        "gift": "赠",
        "voucher_cannot_empty": "支付凭证不能为空",
        "pic_loading": "图片正在加载",
        "amount_between": "之间的金额",
        "card": "卡",
        "note_info": "填写备注信息，更快到账",
        "credit_cord": "收款卡号",
        "rate": "汇率",
        "not_channel": "充值渠道不存在，请联系客服",
        "select_amount": "请选择充值金额",
        "confirm_cancellation_order": "确定取消订单吗",
        "been_submit": "订单已提交，请耐心等待",
        "Eventually_topUp_amount": "最终充值到账金额为",
        "current_rate": "当前汇率",
        "Outstanding_orders": "您有尚未完成的订单，是否继续",
        "Continue": "继续",
        "Cancel_order": "取消订单",
        "bind_succ": "绑定成功",
        "inp_paw": "请先输入密码",
        "remove_bind_succ": "解除绑定成功",
        "first": "第",
        "day": "天",
        "Sports_eSports": "体育电竞",
        "directly": "直属",
        "not_directly": "非直属",
        "amount_not_null": "提现金额不能为空，请填写",
        "WithdrawalAmount": "提现金额",
        "Qbind": "请先绑定",
        "moment_not_bind": "您暂时未绑定",
        "QgoBind": "请前往绑定",
        "replace": "更换",
        "between": "之间",
        "request_submit": "提现请求已提交",
        "ContinueToCarry": "继续提现",
        "GiveUpWithdrawal": "放弃提现",
        "Qxuanding": "提示：请正确选定",
        "jiesuanshihou": "结算时将直接转入此",
        "zhuanghaowanquan": "账号，为了您的资金安全，绑定后不可随意更改，如需修改，请联系客服人员。",
        "phoneNo": "手机号",
        "add": "添加",
        "updateTimeout": "检查更新超时，请确认您的网络是否正常",
        "retry": "重试",
        "err_retry": "下载文件出错，请重试",
        "err_check_network": "网络开小差，请确认您的网络是否正常",
        "no_get_data": "没有获取到资源更新，请稍后重试",
        "network_retry": "网络已断开，请检查您的网络连接是否正常",
        "Quit_game": "退出游戏",
        "ReturnHall": "返回大厅",
        "daozhangUSDT": "到账USDT金额",
    },
};